<template>
  <v-layout row align-center justify-space-around>
    <v-flex xs12 order-lg2 id="sourcesListings">
      <v-flex xs12>
        <v-btn style="position: absolute; left: 5px" outline fab dark small class="elevation-1" color="accent lighten-2" @click="goToPage('first')" :disabled="page === 1">
          <v-icon>first_page</v-icon>
        </v-btn>
        <v-btn outline fab dark small class="elevation-1" color="accent lighten-2" @click="goToPage('previous')" :disabled="page === 1">
          <v-icon>keyboard_arrow_left</v-icon>
        </v-btn>
        <v-btn class="elevation-1 noHover" style="cursor: auto" outline fab dark small color="accent lighten-2">
          <span style="color: #727272">{{ page }}</span>
        </v-btn>
        <v-btn class="elevation-1" outline fab dark small color="accent lighten-2" @click="goToPage('next')" :disabled="lastPage">
          <v-icon>keyboard_arrow_right</v-icon>
        </v-btn>
      </v-flex>
      <v-flex style="min-height: 100px" v-if="dataState === 'loading' || dataState === 'ready'" :class="dataState !== 'ready' ? 'blurClass' : ''">
        <v-list two-line class="pt-0">
          <v-list-group v-for="(item, index) in sources" v-model="item._active" :key="index" append-icon="" no-action>
            <v-list-tile
              :ref="'source' + '-' + index"
              slot="activator"
              :key="item._domain"
              avatar
              @click.stop=""
              class='pa-0 afterHeader'
              :style='index % 2 === 0 ? "background-color: #EFEFEF99" : "background-color: #FFFFFF99"'>
              <v-list-tile-content class='pr-4 sources' @click.stop="goToSource(item._domain)">
                <v-list-tile-title v-html="item._domain" class="pointer"></v-list-tile-title>
              </v-list-tile-content>
              <v-divider vertical></v-divider>
              <v-list-tile-content class='counters' :style="options.sortBy === '_article_count' ? 'background-color: #FFB74D11' : ''">
                <v-list-tile-title class="text-md-center" style="display:flex; justify-content: center"><v-icon small left class="mr-2" color="orange lighten-2">fa-newspaper</v-icon><p style="min-width: 60px">{{ formatNumber(item._article_count) }}</p></v-list-tile-title>
              </v-list-tile-content>
              <v-divider vertical></v-divider>
              <v-list-tile-content class='counters' :style="options.sortBy === '_tweeted_count' ? 'background-color: #64b5f611' : ''">
                <v-list-tile-title class="text-md-center" style="display:flex; justify-content: center"><v-icon small left class="mr-2" color="blue lighten-2">fab fa-twitter</v-icon><p style="min-width: 60px">{{ formatNumber(item._tweeted_count) }}</p></v-list-tile-title>
              </v-list-tile-content>
              <v-divider vertical></v-divider>
              <v-list-tile-content class='counters' style="display: flex; align-items: center; justify-content: center" @click.stop="getArticlesBySource(index, false)">
                <v-list-tile-content><v-btn color="blue white--text">View Articles</v-btn></v-list-tile-content>
              </v-list-tile-content>
            </v-list-tile>
            <!-- <template v-if="articlesDataState === 'ready'"> -->
              <v-list-tile two-line v-for="(item, index1) in articles" :key="index1">
                <v-list-tile-content
                  :key="item._url"
                  avatar
                  class='pa-3 pointer'
                  :style='innerListStyle(index, index1)'
                  @click="goToArticle(item._url)">
                  <v-layout row style="width: 90%;">
                    <v-avatar color="grey" tile size="40" class="mr-2">
                      <img v-if="item._image_url" :src="item._image_url">
                      <v-icon v-else dark>block</v-icon>
                    </v-avatar>
                    <v-list-tile-content class='pr-4 articles'>
                      <v-list-tile-sub-title>{{ item._title.length > 140 ? item._title.slice(0,140) + '...' : item._title }}</v-list-tile-sub-title>
                      <v-list-tile-sub-title>{{ item._tweeted_count + ' tweets | ' + formatDateTime(new Date(item._date_published)) }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-spacer></v-spacer>
                    <v-avatar size=30 class="ml-2" color="secondary">
                      <v-btn icon @click.stop="selectedArticle = item._id; deleteArticleConfirmationDialog = true">
                        <v-icon size="15">fas fa-trash</v-icon>
                      </v-btn>
                    </v-avatar>
                  </v-layout>
                </v-list-tile-content>
              </v-list-tile>
            <v-list-tile class="sourcesListingArticlesList" v-if="articles.length !== item._article_count && articlesDataState === 'ready'"><v-list-tile-content style="width: 100%" class="align-center"><v-btn outline @click.stop="getMoreArticles(index, item._article_count)" class="ma-0 px-2" color="blue white--text">View More</v-btn></v-list-tile-content></v-list-tile>
            <v-list-tile v-if="articlesDataState === 'loading'">
              <v-list-tile-content style="width: 100%" class="align-center">
                <v-progress-circular
                :size="70"
                :width="7"
                color="primary"
                indeterminate></v-progress-circular>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-else-if="articlesDataState === 'error'">
              <div style="display: flex; align-items: center; width: 100%; flex-direction: column"><v-icon style="font-size: 40px !important" class="error--text">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">error connecting to server</p></div>
            </v-list-tile>
          </v-list-group>
        </v-list>
      </v-flex>
      <template v-if="dataState === 'loading'">
        <center class="alternateState">
          <v-progress-circular
            :size="70"
            :width="7"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </center>
      </template>
      <template v-else-if="dataState === 'noData'">
        <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="primary--text" style="font-size: 40px !important;width:100%">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">no data found</p></div>
      </template>
      <template v-else-if="dataState === 'error'">
        <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="error--text" style="font-size: 40px !important">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">error connecting to server</p></div>
      </template>
      <v-flex xs12>
        <v-btn style="position: absolute; left: 5px;" outline fab dark small class="elevation-1" color="accent lighten-2" @click="goToPage('first')" :disabled="page === 1">
          <v-icon>first_page</v-icon>
        </v-btn>
        <v-btn outline fab dark small class="elevation-1" color="accent lighten-2" @click="goToPage('previous')" :disabled="page === 1">
          <v-icon>keyboard_arrow_left</v-icon>
        </v-btn>
        <v-btn class="elevation-1 noHover" style="cursor: auto" outline fab dark small color="accent lighten-2">
          <span style="color: #727272">{{ page }}</span>
        </v-btn>
        <v-btn class="elevation-1" outline fab dark small color="accent lighten-2" @click="goToPage('next')" :disabled="lastPage">
          <v-icon>keyboard_arrow_right</v-icon>
        </v-btn>
      </v-flex>
    </v-flex>
    <v-dialog
      v-model="deleteArticleConfirmationDialog"
      width="300"
    >
      <v-card class="secondary">
        <v-card-title class="headline">Delete Article?</v-card-title>
        <v-card-text>
          <v-btn @click="deleteArticle" :loading="deleteLoading">Confirm</v-btn>
          <v-btn @click="deleteArticleConfirmationDialog = false; selectedArticle = null" :disabled="deleteLoading">Cancel</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<style>
  #sourcesListings .v-list__tile{
    padding-right: 0;
    padding-left: 0;
  }
  #sourcesListings .v-btn:focus:before{
    background-color: white !important;
  }
  #sourcesListings .v-btn--disabled{
    background-color: #e0e0e0 !important;
    border: 1px solid #727272;
    -webkit-box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)!important;
    box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)!important;
  }
  #sourcesListings .v-btn--disabled:focus:before{
    background-color: #e0e0e0 !important;
  }
  #sourcesListings .v-btn--disabled i{
    color: #727272 !important;
  }
</style>

<style scoped>
  .alternateState{
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .blurClass{
    filter: blur(5px);
    -webkit-filter: blur(5px);
  }
  .pointer{ cursor: pointer; }
  .sources{ width: 400px; }
  .v-list__group.v-list__group--active:before, .v-list__group.v-list__group--active:after{
    left: 0;
  }
  .v-list__group__header.v-list__group__header--active .afterHeader:after{
    content: "";
    height: 1px;
    position: absolute;
    -webkit-transition: .3s cubic-bezier(.25,.8,.5,1); 
    transition: .3s cubic-bezier(.25,.8,.5,1); 
    width: 100%;
    left: 0;
    background-color: #ededed;
  }
  .noHover:hover{background-color: white !important}
  .noHover:hover:before{background-color: transparent !important}
</style>

<script>
import axios from 'axios'
import underscore from 'underscore'
import { mapGetters, mapMutations } from 'vuex'
import numeral from 'numeral'
import { formatDateTime } from '@/helpers/formatters'

export default {
  props: {
    filters: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dataState: 'loading',
      articlesDataState: 'noData',
      sources: [],
      page: 1,
      articles: [],
      lastPage: false,
      deleteArticleConfirmationDialog: false,
      selectedArticle: null,
      deleteLoading: false
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('filters', ['getQuery', 'getFilters'])
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    formatDateTime: formatDateTime,
    deleteArticle () {
      this.deleteLoading = true
      axios.all([
        this.$store.dispatch('deleteArticleById', {id: this.selectedArticle, query: '?projectUuid=' + this.getFilters.projectUuid})
      ]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.selectedArticle = null
          this.deleteArticleConfirmationDialog = false
        } else {
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
        this.getData()
        this.deleteLoading = false
      })).catch((err) => {
        this.deleteLoading = false
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    innerListStyle: function (sourceIndex, articleIndex) {
      if (sourceIndex % 2 === 0) {
        if (articleIndex % 2 === 0) {
          return 'background-color: #FFFFFF99'
        } else {
          return 'background-color: #EFEFEF99'
        }
      } else {
        if (articleIndex % 2 === 0) {
          return 'background-color: #EFEFEF99'
        } else {
          return 'background-color: #FFFFFF99'
        }
      }
    },
    formatNumber: function (value) {
      return Number(value) > 999 ? numeral(Number(value)).format('0.0a').toUpperCase() : value
    },
    goToSource: function (source) {
      window.open('http://' + source, '_blank')
    },
    goToArticle: function (url) {
      window.open(url, '_blank')
    },
    goToPage (direction) {
      var newPage = this.page
      if (direction === 'first') {
        newPage = 1
      } else if (direction === 'previous') {
        newPage--
      } else if (direction === 'next') {
        newPage++
      }
      if (newPage !== this.page) {
        this.page = newPage
        this.getData()
      }
    },
    getMoreArticles: function (index, totalArticles) {
      if (this.articles.length !== totalArticles) {
        this.getArticlesBySource(index, true)
      }
    },
    getData: function () {
      this.dataState = 'loading'
      axios.all([
        this.$store.dispatch('getNewsSources', this.getQuery({sortBy: this.options.sortBy, order: this.options.orderBy, pageSize: 30, pageNumber: this.page}))
      ]).then(axios.spread((r1) => {
        if (r1.data.status === 'SUCCESS') {
          r1.data.payload.forEach(function (item) { item._active = false })
          this.sources = r1.data.payload
          if (r1.data.payload.length > 0) {
            this.dataState = 'ready'
            this.lastPage = (r1.data.payload.length < 30)
          } else {
            this.dataState = 'noData'
            this.lastPage = true
          }
        } else {
          this.dataState = 'error'
          this.lastPage = true
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
      })).catch((err) => {
        this.lastPage = true
        this.dataState = 'error'
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    getArticlesBySource: function (index, increment) {
      var timeout = 0
      if (!increment) {
        this.sources.forEach(function (item, idx) { if (idx !== index) item._active = false })
        timeout = 500
      }
      var self = this
      setTimeout(function () {
        var articlesPageNumber = 1
        if (!increment) {
          self.articles = []
          self.sources[index]._active = !self.sources[index]._active
        } else {
          articlesPageNumber = (self.articles.length / 5) + 1
        }
        if (self.sources[index]._active) {
          self.articlesDataState = 'loading'
          axios.all([
            self.$store.dispatch('getArticles', self.getQuery({sortBy: self.options.sortBy === '_tweeted_count' ? '_tweeted_count' : '_date_published', order: self.options.orderBy, domain: self.sources[index]._domain, pageSize: 5, pageNumber: articlesPageNumber}))
          ]).then(axios.spread((response) => {
            if (response.data.status === 'SUCCESS') {
              if (response.data.payload.length > 0) {
                if (increment) {
                  response.data.payload.forEach(function (item) {
                    self.articles.push(item)
                  })
                } else {
                  self.articles = response.data.payload
                }
                self.articlesDataState = 'ready'
              } else {
                self.articlesDataState = 'noData'
              }
            } else {
              self.articlesDataState = 'error'
              self.notify({message: 'Something went wrong while fetching data.', show: true})
            }
          })).catch((err) => {
            self.articlesDataState = 'error'
            self.notify({message: 'Something went wrong while connecting to the server.', show: true})
            console.log(err)
          })
        }
      }, timeout, index)
    }
  },
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler (newVal, oldVal) {
        if (oldVal && newVal && !underscore.isEqual(newVal, oldVal) && this.filters.dirty === false) {
          this.page = 1
          this.getData()
        }
      }
    },
    options: {
      deep: true,
      immediate: true,
      handler (newVal, oldVal) {
        if (oldVal && newVal && !underscore.isEqual(newVal, oldVal) && this.filters.dirty === false) {
          this.page = 1
          this.getData()
        }
      }
    }
  },
  mounted: function () {
    this.getData()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/listings/SourcesListing.vue